<div class="smart-app-banner" *ngIf="showBanner">
  <div class="banner-wrapper">
    <!-- Close Button -->
    <button class="close-button" (click)="onCloseBanner()" aria-label="Close banner">
      <img src="../../../assets/img/close-icon.svg" alt="Close" class="close-icon" />
    </button>
    <div class="avatar-section">
      <div class="app-avatar">
          <img src="../../../assets/img/uniqode-app.svg" alt="Uniqode Cards App" class="app-icon" />
      </div>
    </div>

    <!-- Text Information Section -->
    <div class="text-section">
      <div class="app-name">Uniqode Cards</div>
      <div class="app-developer">Uniqode Phygital, Inc</div>
    </div>

    <!-- Install Button -->
    <button class="install-button" (click)="onInstallApp()">
      {{ installButtonText }}
    </button>
  </div>
</div> 